import { Button, Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import * as operation from '../state/operation';
import * as selector from '../state/selector';

export const MachineVncCheckedFirmwareModal = () => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.MACHINE_DETAILS);
  const dispatch = useDispatch();

  const { machineVncSession } = useSelector((state) => ({
    machineVncSession: selector.selectMachineVncSession(state)
  }));

  /**
   * @context firmware is not supported -> warning modal is shown
   * @description Handle action to close firmware update remindeing mesage
   */
  const handleHideCheckedFirmwareModal = () => {
    dispatch(operation.hideCheckedFirmwareModal());
  };

  return (
    <Modal
      title={t('machineVncCheckedFirmwareModal.title')}
      open={machineVncSession.modal.firmwareChecking.visible}
      className="base-modal no-select"
      closable={false}
      destroyOnClose
      width={550}
      footer={[
        <Button className="cancel-btn" onClick={handleHideCheckedFirmwareModal}>
          {t('machineVncCheckedFirmwareModal.backButton')}
        </Button>
      ]}>
      <pre className="machine-vnc-modal whitespace-normal">
        {t('machineVncCheckedFirmwareModal.description')}
      </pre>
    </Modal>
  );
};
